import { CountryCodes } from '@/enums/general'
import {
  MenPrices as newMenPrices,
  BoysPrices as newBoysPrices,
  SocksDiscountPrices as newSocksDiscountPrices,
  UndershirtsDiscountPrices as newUndershirtsDiscountPrices
} from '@/enums/prices'

type CountryPrices = Record<(typeof CountryCodes)[keyof typeof CountryCodes], number>

interface SizeOption {
  value: number
  label: string
}

export const Orientations = {
  menoriginals: 'men-originals',
  menone: 'men-one',
  boysoriginals: 'boys-originals',
  socksoriginals: 'originals-socks-regular',
  sneakersocksoriginals: 'originals-socks-sneaker',
  womenbralette: 'women-bralette',
  womenhipster: 'women-hipster',
  undershirts: 'men-undershirt'
} as const

// Product group references for socks, as found on productGroupSize.productGroup.reference
export const SocksOrientations = [Orientations.socksoriginals, Orientations.sneakersocksoriginals]

export const NewOrientations = {
  men: 'men',
  boys: 'boys',
  women: 'women',
  addon: 'addon'
} as const

export const OrientationsByGroupIds = {
  1: Orientations.menoriginals,
  2: Orientations.menone,
  3: Orientations.boysoriginals,
  21: Orientations.socksoriginals
} as const

export const OrientationSlugsByGroupIds = {
  1: Orientations.menoriginals,
  2: Orientations.menone,
  3: Orientations.boysoriginals,
  21: Orientations.socksoriginals
} as const

export const OrientationsStartDates = {
  1: '15-04-2015',
  2: '01-01-2019',
  3: '15-4-2018',
  21: '1-9-2021'
} as const

export const OrientationsNamesByGroupIds = {
  1: 'Men Originals',
  2: 'Men One',
  3: 'Boys Originals',
  21: 'Socks'
} as const

export const GroupIdsByName = {
  [Orientations.menoriginals]: Object.keys(OrientationsByGroupIds)[0],
  [Orientations.menone]: Object.keys(OrientationsByGroupIds)[1],
  [Orientations.boysoriginals]: Object.keys(OrientationsByGroupIds)[2],
  [Orientations.socksoriginals]: Object.keys(OrientationsByGroupIds)[3],
  socks: Object.keys(OrientationsByGroupIds)[3]
}

// TODO: move to backend
export const MenPrices: CountryPrices = {
  [CountryCodes.austria]: newMenPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newMenPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newMenPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newMenPrices[CountryCodes.germany],
  [CountryCodes.spain]: newMenPrices[CountryCodes.spain],
  [CountryCodes.france]: newMenPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newMenPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newMenPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newMenPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newMenPrices[CountryCodes.italy],
  [CountryCodes.poland]: newMenPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newMenPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newMenPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newMenPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newMenPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newMenPrices[CountryCodes.finland],
  [CountryCodes.norway]: newMenPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newMenPrices[CountryCodes.czechRepublic]
}

export const WomenPrices: CountryPrices = {
  [CountryCodes.austria]: 12.99,
  [CountryCodes.belgium]: 12.99,
  [CountryCodes.denmark]: 110,
  [CountryCodes.germany]: 12.99,
  [CountryCodes.spain]: 12.99,
  [CountryCodes.france]: 12.99,
  [CountryCodes.netherlands]: 12.99,
  [CountryCodes.unitedKingdom]: 12.99,
  [CountryCodes.sweden]: 151,
  [CountryCodes.italy]: 12.99,
  [CountryCodes.poland]: 57,
  [CountryCodes.switzerland]: 12.99,
  [CountryCodes.ireland]: 12.99,
  [CountryCodes.luxembourg]: 12.99,
  [CountryCodes.portugal]: 12.99,
  [CountryCodes.finland]: 12.99,
  [CountryCodes.norway]: 153,
  [CountryCodes.czechRepublic]: 329
}

export const BoysPrices: CountryPrices = {
  [CountryCodes.austria]: newBoysPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newBoysPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newBoysPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newBoysPrices[CountryCodes.germany],
  [CountryCodes.spain]: newBoysPrices[CountryCodes.spain],
  [CountryCodes.france]: newBoysPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newBoysPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newBoysPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newBoysPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newBoysPrices[CountryCodes.italy],
  [CountryCodes.poland]: newBoysPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newBoysPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newBoysPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newBoysPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newBoysPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newBoysPrices[CountryCodes.finland],
  [CountryCodes.norway]: newBoysPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newBoysPrices[CountryCodes.czechRepublic]
}

export const SocksPrices: CountryPrices = {
  [CountryCodes.austria]: 8.99,
  [CountryCodes.belgium]: 8.99,
  [CountryCodes.denmark]: 67,
  [CountryCodes.germany]: 8.99,
  [CountryCodes.spain]: 8.99,
  [CountryCodes.france]: 8.99,
  [CountryCodes.netherlands]: 8.99,
  [CountryCodes.unitedKingdom]: 8.99,
  [CountryCodes.sweden]: 93,
  [CountryCodes.italy]: 8.99,
  [CountryCodes.poland]: 44,
  [CountryCodes.switzerland]: 9.95,
  [CountryCodes.ireland]: 9.99,
  [CountryCodes.luxembourg]: 9.99,
  [CountryCodes.portugal]: 8.99,
  [CountryCodes.finland]: 9.99,
  [CountryCodes.norway]: 119,
  [CountryCodes.czechRepublic]: 212
}

export const SocksDiscountPrices: CountryPrices = {
  [CountryCodes.austria]: newSocksDiscountPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newSocksDiscountPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newSocksDiscountPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newSocksDiscountPrices[CountryCodes.germany],
  [CountryCodes.spain]: newSocksDiscountPrices[CountryCodes.spain],
  [CountryCodes.france]: newSocksDiscountPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newSocksDiscountPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newSocksDiscountPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newSocksDiscountPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newSocksDiscountPrices[CountryCodes.italy],
  [CountryCodes.poland]: newSocksDiscountPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newSocksDiscountPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newSocksDiscountPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newSocksDiscountPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newSocksDiscountPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newSocksDiscountPrices[CountryCodes.finland],
  [CountryCodes.norway]: newSocksDiscountPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newSocksDiscountPrices[CountryCodes.czechRepublic]
}

export const UndershirtsPrices: CountryPrices = {
  [CountryCodes.austria]: 12.99,
  [CountryCodes.belgium]: 12.99,
  [CountryCodes.denmark]: 97,
  [CountryCodes.germany]: 12.99,
  [CountryCodes.spain]: 12.99,
  [CountryCodes.france]: 12.99,
  [CountryCodes.netherlands]: 12.99,
  [CountryCodes.unitedKingdom]: 12.99,
  [CountryCodes.sweden]: 149,
  [CountryCodes.italy]: 12.99,
  [CountryCodes.poland]: 55,
  [CountryCodes.switzerland]: 12.99,
  [CountryCodes.ireland]: 12.99,
  [CountryCodes.luxembourg]: 12.99,
  [CountryCodes.portugal]: 12.99,
  [CountryCodes.finland]: 12.99,
  [CountryCodes.norway]: 155,
  [CountryCodes.czechRepublic]: 325
}

export const UndershirtsDiscountPrices: CountryPrices = {
  [CountryCodes.austria]: newUndershirtsDiscountPrices[CountryCodes.austria],
  [CountryCodes.belgium]: newUndershirtsDiscountPrices[CountryCodes.belgium],
  [CountryCodes.denmark]: newUndershirtsDiscountPrices[CountryCodes.denmark],
  [CountryCodes.germany]: newUndershirtsDiscountPrices[CountryCodes.germany],
  [CountryCodes.spain]: newUndershirtsDiscountPrices[CountryCodes.spain],
  [CountryCodes.france]: newUndershirtsDiscountPrices[CountryCodes.france],
  [CountryCodes.netherlands]: newUndershirtsDiscountPrices[CountryCodes.netherlands],
  [CountryCodes.unitedKingdom]: newUndershirtsDiscountPrices[CountryCodes.unitedKingdom],
  [CountryCodes.sweden]: newUndershirtsDiscountPrices[CountryCodes.sweden],
  [CountryCodes.italy]: newUndershirtsDiscountPrices[CountryCodes.italy],
  [CountryCodes.poland]: newUndershirtsDiscountPrices[CountryCodes.poland],
  [CountryCodes.switzerland]: newUndershirtsDiscountPrices[CountryCodes.switzerland],
  [CountryCodes.ireland]: newUndershirtsDiscountPrices[CountryCodes.ireland],
  [CountryCodes.luxembourg]: newUndershirtsDiscountPrices[CountryCodes.luxembourg],
  [CountryCodes.portugal]: newUndershirtsDiscountPrices[CountryCodes.portugal],
  [CountryCodes.finland]: newUndershirtsDiscountPrices[CountryCodes.finland],
  [CountryCodes.norway]: newUndershirtsDiscountPrices[CountryCodes.norway],
  [CountryCodes.czechRepublic]: newUndershirtsDiscountPrices[CountryCodes.czechRepublic]
}

export const ProductTypes = {
  boxers: 'boxers',
  socks: 'socks'
} as const

export const ProductCategoryIds = {
  // todo:: remove
  [ProductTypes.boxers]: 1,
  [ProductTypes.socks]: 2
} as const

export const ProductTypesByIds = {
  [ProductCategoryIds[ProductTypes.boxers]]: ProductTypes.boxers,
  [ProductCategoryIds[ProductTypes.socks]]: ProductTypes.socks
} as const

export const mensSizes: SizeOption[] = [
  { value: 1, label: 'XS' },
  { value: 2, label: 'S' },
  { value: 3, label: 'M' },
  { value: 4, label: 'L' },
  { value: 5, label: 'XL' },
  { value: 6, label: 'XXL' },
  { value: 12, label: '3XL' }
]

export const boysSizes: SizeOption[] = [
  { value: 7, label: '104' },
  { value: 8, label: '110-116' },
  { value: 9, label: '122-128' },
  { value: 10, label: '134-140' },
  { value: 11, label: '146-152' }
]

export const Sizes = {
  mens: mensSizes,
  boys: boysSizes,
  all: [...mensSizes, ...boysSizes]
} as const

export const ProductGroupSizeIds = {
  [Orientations.womenbralette]: 152,
  [Orientations.womenhipster]: 156
} as const

export const SizeOrdersGroupedByProductGroup = {
  [Orientations.womenbralette]: [
    'women-bralette-xs',
    'women-bralette-s',
    'women-bralette-m',
    'women-bralette-l',
    'women-bralette-xl'
  ],
  [Orientations.womenhipster]: ['women-hipster-xs', 'women-hipster-s', 'women-hipster-m', 'women-hipster-l', 'women-hipster-xl'],
  [Orientations.menone]: ['men-one-xs', 'men-one-s', 'men-one-m', 'men-one-l', 'men-one-xl', 'men-one-xxl', 'men-one-3xl'],
  [Orientations.menoriginals]: [
    'men-originals-xs',
    'men-originals-s',
    'men-originals-m',
    'men-originals-l',
    'men-originals-xl',
    'men-originals-xxl',
    'men-originals-3xl'
  ],
  [Orientations.undershirts]: [
    'men-undershirt-xs',
    'men-undershirt-s',
    'men-undershirt-m',
    'men-undershirt-l',
    'men-undershirt-xl',
    'men-undershirt-xxl',
    'men-undershirt-3xl'
  ],
  [Orientations.socksoriginals]: ['originals-socks-regular-39-42', 'originals-socks-regular-43-46'],
  [Orientations.sneakersocksoriginals]: ['originals-socks-sneaker-39-42', 'originals-socks-sneaker-43-46']
} as const